"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface DividerProps {
  children?: React.ReactNode;
  className?: string;
}

export function Divider({ children, className }: DividerProps) {
  if (!children) {
    return <hr className={cn("my-4 border-t border-border", className)} />;
  }

  return (
    <div className={cn("relative my-4", className)}>
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-border" />
      </div>
      <div className="relative flex justify-center text-xs">{children}</div>
    </div>
  );
}
